<fgb-banner [pageTitle]="'challenges.page.title' | translate" />

<fgb-page-header [pageTitle]="'challenges.page.title'" [backButtonLink]="'/'"></fgb-page-header>

<div class="container mt-lg-4" [routerLink]="['/badges']">
  <fgbcl-badge-achieved />
</div>

<div class="pt-4 mt-lg-2">
  <fgbcl-scorecard-list-view
    [icon]="'chevron_right'"
    [showPlaceholder]="true"
    [isSponsorInBody]="true"
  ></fgbcl-scorecard-list-view>
</div>
